// Sentinel the server reads as "no upper bound" (Listing::UrlPathBuilder::PRICE_RANGE_MAX).
export const PRICE_UNBOUNDED = 99_999

// Pure price-range math for the slider — knows nothing about the DOM.
export class PriceRange {
  constructor({ min, max, step, gap }) {
    this.min = min
    this.max = max
    this.step = step
    this.gap = gap
  }

  // One step past the real max is the slider's "All" position.
  get sliderMax() {
    return this.max + this.step
  }

  isFullRange(currentMin, currentMax) {
    return currentMin === this.min && currentMax >= this.sliderMax
  }

  // Keep the two handles at least `gap` apart.
  clampMin(currentMin, currentMax) {
    return currentMin + this.gap > currentMax ? currentMax - this.gap : currentMin
  }

  clampMax(currentMin, currentMax) {
    return currentMax - this.gap < currentMin ? currentMin + this.gap : currentMax
  }

  // Slider handle positions and active flag for the persisted values. No persisted
  // max means the full (inactive) range; the server sentinel maps to the "All" position.
  sliderState(persistedMin, persistedMax) {
    if (persistedMax <= 0) return { min: this.min, max: this.sliderMax, active: false }

    const max = persistedMax >= PRICE_UNBOUNDED ? this.sliderMax : Math.min(persistedMax, this.sliderMax)
    return { min: persistedMin, max, active: true }
  }

  // Values the form submits: blank for the full range, sentinel for an open top.
  submitValues(currentMin, currentMax) {
    if (this.isFullRange(currentMin, currentMax)) return { min: "", max: "" }

    return { min: currentMin, max: currentMax >= this.sliderMax ? PRICE_UNBOUNDED : currentMax }
  }

  label(value, currency) {
    return value >= this.sliderMax ? "All" : `${currency}${value.toLocaleString()}`
  }

  trackPercents(currentMin, currentMax, trackPercent) {
    return {
      left: (currentMin / this.sliderMax) * trackPercent,
      right: trackPercent - (currentMax / this.sliderMax) * trackPercent,
    }
  }
}
